export default __webpack_public_path__ + "src/images/packages/kumbu-kumbu-lodge/a9db828d829f6b46a55c2c64efb1add1-4.jpg";